// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles_overlay__YRyOQ","contentContainer":"styles_contentContainer__1eD9n","this":"styles_this__36f8b","header":"styles_header__Ti_rb","content":"styles_content__2tWt4"};